
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:false}) show:boolean
    @Prop({default:()=>{return {}}}) msg:any
    private diaShow = false
    private loading = false
    private SpecBacthStock = ''
    private tablelist:any = []
    @Watch('show')
    private watchShow(val){
      this.diaShow = val
      if(val){
        if(this.msg.ProductType==1){
          this.tablelist = this.msg.ProductMixInfoList
        }else{
          this.tablelist = this.msg.skuDetail
        }
      }
    }

    get allStock(){
      if(this.msg.ProductType==1){
        return Math.min(...this.tablelist.map(v=>{
          return Math.floor(v.Stock/v.ProductCount)
        }))
      }else{
        let list:any = []
        if(this.msg.IsShareStock){
          list = this.tablelist.filter(v=>v.Count==1&&v.SpecValue==this.tablelist[0].SpecValue)
        }else{
          list = this.tablelist
        }
        return list.reduce((pre,cur)=>{
          return pre+=Number(cur.Stock||0)
        },0)
      }
    }

    private confirm(){
      if(this.msg.ProductType!=1&&(!this.msg.skuNames||!this.msg.skuNames.length)){
        this.$emit('confirm',this.tablelist,this.msg,this.allStock)
        this.$emit('close',false)
        return 
      }
      for(let item of this.tablelist){
        if(!item.Stock){
          this.$message.error('请输入库存')
          return 
        }
      }
      this.$emit('confirm',this.tablelist,this.msg,this.allStock)
      this.$emit('close',false)
    }
    private modification(e,key){
      if(!this.SpecBacthStock){
        this.$message.error('请设置库存')
        return 
      }
      this.tablelist = this.tablelist.map(v=>{
        v[key] = this.SpecBacthStock
        return v
      })
    }
    private SharedStock(index){
      if(!this.msg.IsShareStock) return  
      let row = this.tablelist[index]
      this.tablelist = this.tablelist.map((x,i)=>{
        if(this.sameKind(row,x)){
          x.Stock = row.Stock
        }
        return x
      })
      
    }
    private sameKind(row,x){
      let first = false
      let satisfy = false
      let num = 0
      for(let i in this.msg.skuNames){
        if(Number(i)>0){
          let key = 'SpecValue' + (Number(i)+1)
          if(x[key]==row[key]){
            num+=1
          }
          if(num == this.msg.skuNames.length-1){
            satisfy = true
          }
        }else{
          if(x.SpecValue!=row.SpecValue){
            first = true
          }else{
            return false
          }
        }
      }
      return first&&satisfy
    }
    private close(){
      this.SpecBacthStock = ''
      this.$emit('close',false)
    }
  }
